import React from 'react'
import classNames from 'classnames'

const ReservationBox = ({ headerText, icon, children }) => {
    return (
        <div className="trip-reservation__box">
            <div
                className={classNames('trip-reservation__box-header', {
                    'trip-reservation__box-header--icon': icon,
                })}
            >
                {icon ? <img src={icon} alt="user" /> : null}
                {headerText}
            </div>
            {children}
        </div>
    )
}

export default ReservationBox
